module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.c9314fbc.webp";